var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonalizedJobsIcon = function SvgPersonalizedJobsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.773 15.411H2.297a.173.173 0 0 1-.173-.172V1.034c0-.095.078-.172.173-.172h11.475c.095 0 .173.077.173.172v14.205a.171.171 0 0 1-.172.172ZM2.47 15.068H13.6V1.206H2.47v13.862Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.034 7.76a2.64 2.64 0 0 1-1.872-.772 2.611 2.611 0 0 1-.775-1.863c0-.705.275-1.366.775-1.864a2.636 2.636 0 0 1 1.872-.771 2.64 2.64 0 0 1 1.872.771c.5.497.775 1.159.775 1.864 0 .704-.275 1.365-.775 1.863a2.64 2.64 0 0 1-1.872.772Zm0-4.927a2.3 2.3 0 0 0-2.302 2.292 2.3 2.3 0 0 0 2.302 2.29 2.3 2.3 0 0 0 2.302-2.29 2.3 2.3 0 0 0-2.302-2.292Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.035 5.784c-.605 0-1.097-.49-1.097-1.09 0-.602.492-1.092 1.097-1.092.604 0 1.096.49 1.096 1.09 0 .602-.492 1.092-1.096 1.092Zm0-1.84a.75.75 0 0 0-.751.748.75.75 0 0 0 .75.748.75.75 0 0 0 .752-.748.75.75 0 0 0-.751-.747Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.536 7.254a.173.173 0 0 1-.173-.172v-.209c0-.6-.49-1.088-1.093-1.088h-.472c-.603 0-1.093.488-1.093 1.088v.21a.173.173 0 0 1-.346 0v-.21c0-.79.646-1.432 1.439-1.432h.472c.793 0 1.439.643 1.439 1.432v.21a.172.172 0 0 1-.173.171ZM9.474 9.86H5.331a.173.173 0 0 1-.173-.172c0-.095.078-.172.173-.172h4.143c.095 0 .173.077.173.172a.173.173 0 0 1-.173.172ZM7.786 11.465H5.331a.173.173 0 0 1-.173-.172c0-.095.078-.172.173-.172h2.455c.095 0 .173.077.173.172a.173.173 0 0 1-.173.172ZM9.608 13.07H5.331a.173.173 0 0 1-.173-.173c0-.094.078-.171.173-.171h4.277c.095 0 .173.077.173.171a.173.173 0 0 1-.173.172ZM4.43 9.688a.172.172 0 1 1-.345 0 .172.172 0 0 1 .344 0ZM4.43 11.293a.172.172 0 0 1-.346 0 .172.172 0 0 1 .345 0ZM4.43 12.897a.172.172 0 1 1-.346 0 .172.172 0 0 1 .345 0Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 0.2
  })));
};

export default SvgPersonalizedJobsIcon;